import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { FilterCreators } from '../../../../store/actions/filter';
import QntClients from './QntClients';
import QntMessage from './QntMessage';
import QntSession from './QntSession';
import QntMessageChannel from './QntMessageChannel';
import TimeAttendance from './AttendanceTime';
import FlowTree from './FlowTree';
import Demography from './Demography';
import Tags from './Tags';

/**
 * Component for display the correct page that was selected
 *
 * @param {string} { subPage }
 * @returns
 */
const BotReport = ({ filter, subPage }) => {
  const [parentFilter, setParentFilter] = useState(filter);

  /**
   * Call when the filter button on the FilterData is called
   */
  const onClickFilter = async () => {
    setParentFilter(filter);
  };

  /** Holder for component references */
  const pages = {
    botNumberClients: (
      <QntClients parentFilter={parentFilter} onClickFilter={onClickFilter} />
    ),
    botNumberMessages: (
      <QntMessage parentFilter={parentFilter} onClickFilter={onClickFilter} />
    ),
    botNumberSessions: (
      <QntSession parentFilter={parentFilter} onClickFilter={onClickFilter} />
    ),
    botNumberMessagesByChannel: (
      <QntMessageChannel
        parentFilter={parentFilter}
        onClickFilter={onClickFilter}
      />
    ),
    botAttendanceTime: (
      <TimeAttendance
        parentFilter={parentFilter}
        onClickFilter={onClickFilter}
      />
    ),
    botTreeFlow: (
      <FlowTree parentFilter={parentFilter} onClickFilter={onClickFilter} />
    ),
    botDemography: (
      <Demography parentFilter={parentFilter} onClickFilter={onClickFilter} />
    ),
    botTags: <Tags parentFilter={parentFilter} onClickFilter={onClickFilter} />,
  };

  return <div className="container-all-history">{pages[subPage]}</div>;
};

const mapStateToProps = (state) => {
  return {
    filter: state.filter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ ...FilterCreators }, dispatch);
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BotReport)
);
